<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->

    <Banner
      title=""
      subtitle=""
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <!-- //메뉴 -->
    <div class="width_wrap">
      <Loading v-show="isLoading" />
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">
          [개인] 검사 및 상담코칭 신청서 작성<span></span>
        </h1>
        <!-- //서브 타이틀영역 -->
        <div v-if="isLoggedIn" class="st_myreg_customize_form">
          <form
            name="myreg_form"
            ENCTYPE="multipart/form-data"
            style="margin: 0"
          >
            <table class="st_myreg_form">
              <caption>
                피검자 기본정보
              </caption>
              <colgroup>
                <col style="width: 220px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>성 명 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="ex_name"
                      id="ex_name"
                      v-model="ex_name"
                    />
                    <n-button
                      @click="fetchMyExamineeInfos()"
                      :loading="isHistoryLoading"
                      type="primary"
                      size="small"
                      ghost
                      style="margin-left: 8px"
                    >
                      기존정보 불러오기
                    </n-button>
                  </td>
                </tr>
                <tr>
                  <th>성별 <span class="st_myreg_required">*</span></th>
                  <td>
                    <label style="display: inline-block; cursor: pointer"
                      ><input
                        type="radio"
                        name="ex_gender"
                        id="ex_gender_m"
                        value="m"
                        v-model="ex_gender"
                      /><span>남</span></label
                    >
                    <label style="display: inline-block; cursor: pointer"
                      ><input
                        type="radio"
                        name="ex_gender"
                        id="ex_gender_f"
                        value="f"
                        v-model="ex_gender"
                      /><span>여</span></label
                    >
                  </td>
                </tr>
                <tr>
                  <th>생년월일 <span class="st_myreg_required">*</span></th>
                  <td>
                    <select name="dob_year" v-model="dob_year">
                      <option disabled value="">----</option>
                      <option
                        v-for="year in availableYears"
                        :key="year"
                        :value="year"
                      >
                        {{ year }}
                      </option>
                    </select>
                    년
                    <select name="dob_month" v-model="dob_month">
                      <option value="">--</option>
                      <option
                        v-for="m in 12"
                        :key="m"
                        :value="String(m).padStart(2, '0')"
                      >
                        {{ String(m).padStart(2, "0") }}
                      </option>
                    </select>
                    월
                    <select name="dob_day" v-model="dob_day">
                      <option value="">--</option>
                      <option
                        v-for="day in 31"
                        :key="day"
                        :value="String(day).padStart(2, '0')"
                      >
                        {{ String(day).padStart(2, "0") }}
                      </option>
                    </select>
                    일
                  </td>
                </tr>
                <tr>
                  <th>
                    소속 학교 | 학년(또는 학과, 전공 등)<span
                      class="st_myreg_required"
                      >*</span
                    >
                  </th>
                  <td>
                    <input
                      type="text"
                      name="ex_school_info"
                      id="ex_school_info"
                      v-model="ex_school_info"
                    />
                  </td>
                </tr>
                <tr>
                  <th>우편번호<span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="postCode"
                      id="postCode"
                      v-model="address.postCode"
                      style="width: 120px"
                      disabled
                    />
                    <n-button
                      @click="openPostcodeSearch"
                      size="small"
                      style="margin-left: 5px"
                    >
                      주소검색
                    </n-button>
                  </td>
                </tr>
                <tr>
                  <th>학교 주소<span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="address"
                      id="address"
                      v-model="address.address"
                      style="width: 100%"
                      disabled
                    />
                  </td>
                </tr>
                <tr>
                  <th>Email 주소<span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="ex_receiver_email"
                      id="ex_receiver_email"
                      v-model="ex_receiver_email"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="st_myreg_form">
              <caption>
                보호자 기본정보
              </caption>
              <colgroup>
                <col style="width: 220px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>성 명 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input type="text" name="name" id="name" v-model="name" />
                  </td>
                </tr>
                <tr>
                  <th>
                    피검자와의 관계<span class="st_myreg_required">*</span>
                  </th>
                  <td>
                    <input
                      type="text"
                      name="relationship"
                      id="relationship"
                      v-model="relationship"
                    />
                  </td>
                </tr>

                <tr>
                  <th>Email 주소<span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="receiver_email"
                      id="receiver_email"
                      v-model="receiver_email"
                    />
                  </td>
                </tr>
                <tr>
                  <th>핸드폰 번호<span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="phone_number"
                      id="phone_number"
                      v-model="phone_number"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="st_myreg_form st_myreg_mgt myreg_cnt_use">
              <caption>
                상품 신청 및 진행 상세정보
              </caption>
              <colgroup>
                <col style="width: 180px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>신청 상품</th>
                  <td>
                    <ul>
                      <template
                        v-if="selectedProductGroup"
                        v-for="item in selectedProductGroup.products"
                        :key="item.PK"
                      >
                        <li>
                          <span>{{ item.name }}</span>
                        </li>
                      </template>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>상담 방법<span class="st_myreg_required">*</span></th>
                  <td>
                    <label style="display: inline-block; cursor: pointer"
                      ><input
                        type="radio"
                        name="counsel_type"
                        id="counsel_type_offline"
                        value="offline"
                        v-model="counsel_type"
                      /><span>연구소 내방</span></label
                    >
                    <label style="display: inline-block; cursor: pointer"
                      ><input
                        type="radio"
                        name="counsel_type"
                        id="counsel_type_online"
                        value="online"
                        v-model="counsel_type"
                      /><span>On-Line</span></label
                    >
                  </td>
                </tr>
                <tr>
                  <th>검사 실시일 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="date"
                      name="s_v7"
                      :min="`${test_target_date_min}`"
                      :max="`${test_target_date_max}`"
                      v-model="test_target_date"
                      id="datepicker_s_v7"
                      style="width: 120px"
                    />
                    <span style="color: red">
                      - 검사 실시 예정일로부터 15일 안에 검사를 실시하여야
                      합니다.</span
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    상담코칭 예정일<span class="st_myreg_required">*</span>
                  </th>
                  <td>
                    <input
                      type="date"
                      name="s_v8"
                      :min="`${test_target_date_min}`"
                      :max="`${test_target_date_max}`"
                      v-model="counsel_target_date"
                      id="datepicker_s_v8"
                      style="width: 120px"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="st_myreg_form st_myreg_mgt myreg_cnt_use">
              <caption>
                결제 정보
              </caption>
              <colgroup>
                <col style="width: 180px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>신청 상품</th>
                  <td>
                    <ul>
                      <template
                        v-if="selectedProductGroup"
                        v-for="item in selectedProductGroup.products"
                        :key="item.PK"
                      >
                        <li>
                          <span>{{ item.name }}</span>
                        </li>
                      </template>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>결제 금액</th>
                  <td>
                    <template
                      v-if="selectedProductGroup && selectedProductGroup.price"
                    >
                      <input
                        type="hidden"
                        name="total_price"
                        id="total_price"
                        value="{{ selectedProductGroup.price : 0 }}"
                      />
                      <span id="total_price_str"
                        >{{
                          selectedProductGroup.price.toLocaleString()
                        }}원</span
                      >
                    </template>
                    <template v-else>
                      <input
                        type="hidden"
                        name="total_price"
                        id="total_price"
                        value="0"
                      />
                      <span v-if="selectedProductGroup">0원</span>
                    </template>
                  </td>
                </tr>
                <tr>
                  <th>결제계좌</th>
                  <td>우리은행 : 1005-104-783814, 예금주:주식회사코코랩</td>
                </tr>
                <tr>
                  <th>입금자명<span style="color: red">*.</span></th>
                  <td>
                    <input
                      type="text"
                      name="deposit_name"
                      v-model="deposit_name"
                      id="deposit_name"
                      style="width: 120px"
                      class="st_myreg_input_txt"
                    />
                    <p class="error-message">
                      * 입금자명은 반드시 피검자 성명으로 기재해야 합니다.
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>입금 예정일<span style="color: red">*</span></th>
                  <td>
                    <input
                      type="date"
                      name="bank_date"
                      :min="`${bank_date_min}`"
                      :max="`${bank_date_max}`"
                      v-model="bank_date"
                      id="bank_date"
                      style="width: 120px"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
          <div class="st_myreg_btn_wrap">
            <button
              @click="confirmTestRequest"
              class="st_myreg_btn_type1 st_myreg_highlight"
            >
              신청하기
            </button>
          </div>
        </div>
        <div v-else>로그인 후 사용해 주세요.</div>
      </div>
    </div>
  </div>
  <!-- PersonSelectorPopup을 위한 n-modal -->
  <n-modal
    v-model:show="showPersonPop"
    preset="card"
    style="width: 750px"
    title="피검자 정보 선택"
    :mask-closable="false"
    @update:show="(value: boolean) => showPersonPop = value"
  >
    <div
      v-if="!examineeInfos || examineeInfos.length === 0"
      class="no-data"
      style="text-align: center; padding: 20px"
    >
      <p>선택할 인물 정보가 없습니다.</p>
    </div>
    <div v-else style="max-height: 500px; overflow-y: auto">
      <n-data-table
        :columns="examineeTableColumns"
        :data="examineeInfos"
        :single-line="false"
        :row-key="(row: any) => row.SK || (row.examinees[0]?.name + row.examinees[0]?.dob)"
      />
    </div>
    <template #footer>
      <div style="display: flex; justify-content: flex-end">
        <n-button
          @click="confirmExamineeSelectionFromModal"
          :disabled="!selectedExamineeKeyInModal"
          type="primary"
          style="margin-right: 10px"
          >선택</n-button
        >
        <n-button @click="closePersonPopup">닫기</n-button>
      </div>
    </template>
  </n-modal>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, h, watch } from "vue"; // h 추가
import { useRoute, useRouter } from "vue-router"; // $route 접근을 위해 useRoute 임포트
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common.ts";
import * as constant from "@/constants/constant";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import {
  NModal,
  NIcon,
  NRadio,
  NDataTable,
  NButton,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui"; // NButton, NRadio, NDataTable 추가
import { ChevronForward } from "@vicons/ionicons5"; // ChevronForward는 템플릿 다른 곳에서 사용될 수 있으므로 유지

import { useAuth } from "@/composables/useAuth";
const { isLoggedIn, loggedInUserId, isOrgUser, isOrgAdmin } = useAuth();
import { Product, ProductGroup } from "@/model/product";
import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import { useActionDialog } from "@/composables/useDialog";
const { show: showActionDialog } = useActionDialog();
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();

watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

const message = useMessage();
const notification = useNotification();
const dialog = useDialog(); // useDialog는 confirmTestRequest에서 사용

const getPersonalProductCallable = getCallable("getProductGroups");
const productGroupList = ref<ProductGroup[]>([]);
const selectedProductGroup = ref<ProductGroup | null>(null);

const getCallApiCallable = getCallable("callApi");
const createOrder = "createOrder";
const remote_getMyExaminees = getCallable("getMyExaminees");

const isLoading = ref(false);
const isHistoryLoading = ref(false);
const isProcess = ref(false);
const isHovered = ref(false);
const availableYears = ref<number[]>([]);
const test_target_date = ref("");
const test_target_date_min = ref("");
const test_target_date_max = ref("");
const counsel_target_date = ref("");

const bank_date = ref("");
const bank_date_min = ref("");
const bank_date_max = ref("");

const route = useRoute();
const router = useRouter();

const now = new Date();
test_target_date.value = common.formatDateToYYYY_MM_DD(now);
counsel_target_date.value = common.formatDateToYYYY_MM_DD(now);
test_target_date_min.value = test_target_date.value;
const maxTargetDate = new Date(now);
maxTargetDate.setDate(now.getDate() + 90);
test_target_date_max.value = common.formatDateToYYYY_MM_DD(maxTargetDate);

const currentYear = now.getFullYear() - 6;
const startYear = currentYear - 50;
for (let year = currentYear; year >= startYear; year--) {
  availableYears.value.push(year);
}

bank_date.value = common.formatDateToYYYY_MM_DD(now);
bank_date_min.value = bank_date.value;
const maxBankDate = new Date(now);
maxBankDate.setDate(now.getDate() + 7);
bank_date_max.value = common.formatDateToYYYY_MM_DD(maxBankDate);

const showPersonPop = ref(false);
const ex_name = ref(null);
const ex_gender = ref(null);
const dob_year = ref(null);
const dob_month = ref(null);
const dob_day = ref(null);
const ex_school_info = ref(null);
const examineeInfos = ref([]);
const selectedExamineeKeyInModal = ref<string | null>(null); // 모달 내 선택된 피검자 정보의 키
const deposit_name = ref(null);
const ex_receiver_email = ref(null);
const name = ref(null);
const relationship = ref(null);
const receiver_email = ref(null);
const phone_number = ref(null);
const counsel_type = ref(null);

const address = ref({
  postCode: "",
  address: "",
  addressDetail: "",
});

function closePersonPopup() {
  showPersonPop.value = false;
}
function handlePersonSelection(personData) {
  if (personData) {
    ex_name.value = personData.name;
    dob_year.value = personData.dob.substring(0, 4);
    dob_month.value = personData.dob.substring(4, 6);
    dob_day.value = personData.dob.substring(6, 8);
    ex_gender.value = personData.gender.substring(0, 1);
    ex_school_info.value = personData.school_info;
    ex_receiver_email.value = personData.email;
    address.value = personData.address;
  }

  closePersonPopup(); // 모달 닫기
}
async function fetchMyExamineeInfos() {
  if (examineeInfos.value.length > 0) {
    showPersonPop.value = true; // 이미 정보가 있으면 바로 팝업 표시
    return;
  }
  isHistoryLoading.value = true;
  try {
    const result = await remote_getMyExaminees();
    if (common.evalFunctionResult(result)) {
      const history = common.getItemListFromFunctionResult(result);
      if (!history || history.length == 0) {
        notification.info({
          title: "정보 없음",
          content:
            "과거 검사를 실시한 정보가 없습니다.\n* 검사를 실시하면 피검자 정보가 자동 저장되어 다음 검사 신청시 불러올 수 있습니다.",
          duration: 5000, // 5초
        });
        return;
      } else {
        examineeInfos.value = history;
        showPersonPop.value = true; // 팝업 표시
      }
    } else {
      console.error(
        "fetchMyExamineeInfos - 데이터 가져오기 실패:",
        common.getResultError(result)
      );
      notification.error({
        title: "오류",
        content: "피검자 정보를 가져오는 데 실패했습니다.",
        duration: 3000,
      });
      return [];
    }
  } catch (error: any) {
    console.error("fetchMyExamineeInfos - API 호출 실패:", error);
    notification.error({
      title: "오류",
      content: `피검자 정보 로딩 중 오류: ${error.message}`,
      duration: 3000,
    });
    return [];
  } finally {
    isHistoryLoading.value = false;
  }
}

const examineeTableColumns = computed(() => [
  {
    title: "선택",
    key: "selection",
    width: 70,
    align: "center",
    render(row: any) {
      // row는 examineeInfos 배열의 각 항목 (프로젝트 객체)
      const projectKey =
        row.SK || row.examinees[0]?.name + row.examinees[0]?.dob; // 고유 키 생성
      return h(NRadio, {
        name: "examineeSelectionGroupInModal", // 라디오 그룹명
        checked: selectedExamineeKeyInModal.value === projectKey,
        value: projectKey, // 라디오 버튼의 값으로 고유 키 사용
        onUpdateChecked: (checked: boolean) => {
          if (checked) {
            selectedExamineeKeyInModal.value = projectKey;
          }
        },
      });
    },
  },
  {
    title: "검사이름",
    key: "name",
    resizable: true,
  },
  {
    title: "검사실시일",
    key: "start_target_date",
    resizable: true,
    render: (row: any) => common.getYYYMMDDStringFormat(row.start_target_date),
  },
  {
    title: "이름",
    key: "examineeName",
    resizable: true,
    render: (row: any) => row.examinees[0]?.name || "N/A",
  },
  {
    title: "성별",
    key: "examineeGender",
    resizable: true,
    render: (row: any) => {
      return common.getGenderString(row.examinees[0]?.gender);
    },
  },
  {
    title: "생년월일",
    key: "examineeDob",
    resizable: true,
    render: (row: any) => row.examinees[0]?.dob || "N/A",
  },
]);

function confirmExamineeSelectionFromModal() {
  if (selectedExamineeKeyInModal.value) {
    const selectedProject = examineeInfos.value.find(
      (p: any) =>
        (p.SK || p.examinees[0]?.name + p.examinees[0]?.dob) ===
        selectedExamineeKeyInModal.value
    );
    if (
      selectedProject &&
      selectedProject.examinees &&
      selectedProject.examinees.length > 0
    ) {
      handlePersonSelection(selectedProject.examinees[0]); // 기존 함수 재활용
    }
  }
  selectedExamineeKeyInModal.value = null; // 선택 초기화
  closePersonPopup(); // 모달 닫기
}

function _checkAvailableConfirm() {
  // 모든 에러 메시지가 비어있어야 유효
  return (
    !exNameError.value &&
    !depositNameError.value &&
    !dobError.value &&
    !genderError.value &&
    !receiverEmailError.value &&
    !testTargetDateError.value &&
    !bankDateError.value &&
    !exReceiverEmailError.value &&
    !exSchooclInfoError.value &&
    !addressError.value &&
    !nameError.value &&
    !relationshipError.value &&
    !phoneNumberError.value &&
    !counselTypeError.value &&
    !counselTargetDateError.value
  );
}

function _getErrorMessage() {
  let message = "입력값을 확인하세요.";

  if (exNameError.value) return exNameError.value;
  if (genderError.value) return genderError.value;
  if (dobError.value) return dobError.value;
  if (exSchooclInfoError.value) return exSchooclInfoError.value;
  if (addressError.value) return addressError.value;
  if (exReceiverEmailError.value) return exReceiverEmailError.value;
  if (nameError.value) return nameError.value;
  if (relationshipError.value) return relationshipError.value;
  if (receiverEmailError.value) return receiverEmailError.value;
  if (phoneNumberError.value) return phoneNumberError.value;
  if (counselTypeError.value) return counselTypeError.value;
  if (counselTargetDateError.value) return counselTargetDateError.value;
  if (testTargetDateError.value) return testTargetDateError.value;
  if (depositNameError.value) return depositNameError.value;
  if (bankDateError.value) return bankDateError.value;

  return message;
}
const exNameError = computed(() => {
  if (!ex_name.value) return `피검자명을 입력해야 합니다.`;
  return "";
});
const depositNameError = computed(() => {
  if (!deposit_name.value) return `입금자명을 입력해야 합니다.`;
  return "";
});
const dobError = computed(() => {
  if (!dob_year.value || !dob_month.value || !dob_day.value)
    return `피검자 생년월일을 지정해야 합니다.`;
  const dob = `${dob_year.value}${dob_month.value}${dob_day.value}`;
  if (dob.length !== 8) return `피검자 생년월일 형식이 올바르지 않습니다.`;
  // 추가적인 날짜 유효성 검사 (예: 2월 30일 등)는 필요시 common.isValidDate 같은 함수로 구현
  return "";
});
const genderError = computed(() => {
  if (!ex_gender.value) return `피검자 성별을 지정해야 합니다.`;
  return "";
});
const receiverEmailError = computed(() => {
  if (!receiver_email.value) return "보호자 이메일을 입력해야 합니다.";
  // Basic email format validation using a regular expression
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(receiver_email.value))
    return "올바른 이메일 형식이 아닙니다.";
  return "";
});
const testTargetDateError = computed(() => {
  if (!test_target_date.value) return "검사 실시일을 선택해야 합니다.";
  return "";
});
const bankDateError = computed(() => {
  if (!bank_date.value) return "입금 예정일을 선택해야 합니다.";
  return "";
});

const exReceiverEmailError = computed(() => {
  if (!ex_receiver_email.value) return "피검자 이메일을 입력해야 합니다.";
  // Basic email format validation using a regular expression
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(ex_receiver_email.value))
    return "올바른 이메일 형식이 아닙니다.";
  return "";
});
const exSchooclInfoError = computed(() => {
  if (!ex_school_info.value) return "소속 학교 | 학년을 입력해야 합니다.";
  return "";
});
const addressError = computed(() => {
  if (!address.value.postCode) return "학교 주소를 입력해야 합니다.";
  return "";
});
const nameError = computed(() => {
  if (!name.value) return "보호자 성명을 입력해야 합니다.";
  return "";
});
const relationshipError = computed(() => {
  if (!relationship.value) return "피검자와의 관계를 입력해야 합니다.";
  return "";
});
const phoneNumberError = computed(() => {
  if (!phone_number.value) return "핸드폰 번호를 입력해야 합니다.";
  // Basic email format validation using a regular expression
  const phoneRegex = /^\d{2,3}-\d{3,4}-\d{4}$/;
  if (!phoneRegex.test(phone_number.value))
    return "전화번호 형식이 올바르지 않습니다. (예: 02-123-4567 또는 010-1234-5678)";
  return "";
});

const counselTypeError = computed(() => {
  if (!counsel_type.value) return "상담 방법을 선택해야 합니다.";
  return "";
});

const counselTargetDateError = computed(() => {
  if (!counsel_target_date.value) return "상담코칭 예정일을 선택해야 합니다.";
  return "";
});
async function confirmTestRequest() {
  if (!_checkAvailableConfirm()) {
    let errorMessase = _getErrorMessage();
    notification.error({
      title: "입력 오류",
      content: errorMessase,
      duration: 3000,
    });
    return;
  }

  showActionDialog({
    title: "확인",
    content: "검사 신청을 진행하시겠습니까?",
    positiveText: "네",
    negativeText: "아니요",
    positiveButtonProps: { type: "primary" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      const cAuth = common.getLocalAuth();
      if (!cAuth) {
        notification.error({
          title: "오류",
          content: "로그인 정보가 없습니다.",
          duration: 3000,
        });

        isProcess.value = false;
        isLoading.value = false;
        message.destroyAll();
        return;
      }

      const dob = `${dob_year.value}${dob_month.value}${dob_day.value}`;
      const testTargetDate = test_target_date.value.replace(/-/g, "");
      const counselTargetDate = counsel_target_date.value.replace(/-/g, "");
      let orderProducts: any[] = [];
      if (selectedProductGroup.value && selectedProductGroup.value.products) {
        orderProducts = selectedProductGroup.value.products.map(
          (productItem) => {
            return {
              prod_id: productItem.SK, // 상품(Product)의 SK
              name: productItem.name,
              price: productItem.price,
              type: productItem.type, // Product 모델에 type이 있다면 사용
              personal_template_form_id: productItem.personal_template_form_id, // Product 모델에 있다면 사용
              projects: [
                {
                  num: 1,
                  name: productItem.name, // 각 상품의 이름으로 설정
                  start_target_date: testTargetDate,
                  counsel_target_date: counselTargetDate,
                  counsel_type: counsel_type.value,
                  examinees: [
                    {
                      num: 1,
                      name: ex_name.value,
                      gender: ex_gender.value,
                      dob: dob,
                      school_info: ex_school_info.value,
                      address: address.value,
                      email: ex_receiver_email.value,
                    },
                  ],
                },
              ],
            };
          }
        );
      } else {
        notification.error({
          title: "오류",
          content: "선택된 상품 정보가 없습니다.",
          duration: 3000,
        });
        message.destroyAll();
        return;
      }

      let payload = {
        client: cAuth,
        payment_method: {
          type: "bank_deposit",
          deposit_name: deposit_name.value,
          bank_date: bank_date.value,
          bank_name: "우리은행 : 1005-104-783814",
        },
        totalPrice: selectedProductGroup.value
          ? selectedProductGroup.value.price
          : 0,
        receiver_email: receiver_email.value,
        products: orderProducts,
        guardian: {
          name: name.value,
          relationship: relationship.value,
          phone_number: phone_number.value,
        },
        type: constant.orderType.INDIVIDUAL,
      };

      try {
        const result = await getCallApiCallable(
          makeCallApiParam(createOrder, payload)
        );
        message.destroyAll(); // 이전 로딩 메시지 제거
        if (common.evalFunctionResult(result)) {
          notification.success({
            title: "성공",
            content:
              "신청이 접수되었습니다.\n입금 및 관리자의 승인 후 진단이 가능합니다.",
            duration: 3000,
          });
          router.push({ name: USER_ROUTES.Mypage.Order.Personal.Name });
        } else {
          throw new Error(
            common.getResultError(result) || "신청 처리 중 오류가 발생했습니다."
          );
        }
      } catch (error: any) {
        message.destroyAll();
        console.error("confirmTestRequest API 호출 실패:", error);
        notification.error({
          title: "신청 실패",
          content:
            common.getResultError(error) || "신청 처리 중 오류가 발생했습니다.",
          duration: 3000,
        });
      }
    },
    onCancel: () => {
      message.info("신청이 취소되었습니다.");
    },
  });
}

async function fetchProducts() {
  const productKey = route.params.product_key as string;
  if (!productKey) {
    notification.error({
      title: "오류",
      description: "상품 키가 제공되지 않았습니다.",
      duration: 3000,
    });
    return;
  }
  isLoading.value = true;
  try {
    const result = await getPersonalProductCallable({}); // 모든 상품 그룹 가져오기
    if (common.evalFunctionResult(result)) {
      const allProductGroups = common.getItemListFromFunctionResult(
        result
      ) as ProductGroup[];
      productGroupList.value = allProductGroups;
      const foundProductGroup = allProductGroups.find(
        (group) => group.product_key === productKey
      );
      if (foundProductGroup) {
        selectedProductGroup.value = foundProductGroup;
      } else {
        notification.error({
          title: "오류",
          description: `상품(키: ${productKey})을 찾을 수 없습니다.`,
          duration: 3000,
        });
        selectedProductGroup.value = null;
      }
    } else {
      notification.error({
        title: "오류",
        description: `상품 목록 조회 실패: ${common.getResultError(result)}`,
        duration: 3000,
      });
      selectedProductGroup.value = null;
    }
  } catch (err: any) {
    console.error("fetchProducts 에러:", err);
    notification.error({
      title: "심각한 오류",
      description: `상품 목록을 가져오는 중 예외가 발생했습니다: ${err.message}`,
      duration: 3000,
    });
    selectedProductGroup.value = null;
  } finally {
    isLoading.value = false;
  }
}

const openPostcodeSearch = async () => {
  if (
    typeof (window as any).daum === "undefined" ||
    typeof (window as any).daum.Postcode === "undefined"
  ) {
    await useAlert(
      "Daum 우편번호 서비스가 로드되지 않았습니다. 페이지를 새로고침하거나 관리자에게 문의하세요."
    );
    return;
  }
  new (window as any).daum.Postcode({
    oncomplete: (data: any) => {
      let addr = ""; // 주소 변수
      let extraAddr = ""; // 참고항목 변수

      //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
      if (data.userSelectedType === "R") {
        // 사용자가 도로명 주소를 선택했을 경우
        addr = data.roadAddress;
      } else {
        // 사용자가 지번 주소를 선택했을 경우(J)
        addr = data.jibunAddress;
      }

      // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
      if (data.userSelectedType === "R") {
        // 법정동명이 있을 경우 추가한다. (법정리는 제외)
        // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
        if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
          extraAddr += data.bname;
        }
        // 건물명이 있고, 공동주택일 경우 추가한다.
        if (data.buildingName !== "" && data.apartment === "Y") {
          extraAddr +=
            extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
        }
        // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
        if (extraAddr !== "") {
          extraAddr = " (" + extraAddr + ")";
        }
      }

      address.value.postCode = data.zonecode;
      address.value.address = addr + extraAddr;
    },
  }).open();
};

onMounted(async () => {
  fetchProducts();
});
</script>

<style scoped>
.minlength-validation-container {
  font-family: sans-serif;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  max-width: 450px;
  margin: 20px auto;
  background-color: #fff;
}
/* 에러 시 스타일 */
input.invalid-input {
  border-color: red;
  background-color: #fff0f0;
}
/* 에러 메시지 스타일 */
.error-message {
  color: red;
  font-size: 0.85em;
  margin-top: 5px;
  min-height: 1.1em; /* 메시지 없을 때 레이아웃 흔들림 방지 */
}
</style>
<style scoped>
button {
  margin: 5px;
  padding: 10px 15px;
  cursor: pointer;
}
</style>
<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.st_myreg_title {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.st_myreg_mgt {
  margin-top: 40px;
}
.st_myreg_form * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
}
.st_myreg_form {
  width: 100%;
  border-top: 2px solid #a5a5a5;
  border-bottom: 1px solid #a5a5a5;
  background: #fff;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}
.st_myreg_form + .st_myreg_form {
  margin-top: 40px;
}
.st_myreg_form caption {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
}
.st_myreg_form tbody tr th {
  position: relative;
  height: 30px;
  padding: 10px;
  border-top: 1px solid #ddd;
  background: #f5f5f5;
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  font-weight: 500;
}
.st_myreg_form tbody tr th:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background: #ddd;
}
.st_myreg_form tbody tr td {
  height: 30px;
  padding: 10px;
  border-top: 1px solid #ddd;
  background: #fff;
  font-size: 13px;
  color: #666;
  line-height: 22px;
}
.st_myreg_form tbody tr:first-child th,
.st_myreg_form tbody tr:first-child td {
  border-top-width: 0;
}
.st_myreg_form tbody tr td input[type="text"],
.st_myreg_form tbody tr td input[type="number"],
.st_myreg_form tbody tr td input[type="password"] {
  box-sizing: border-box;
  max-width: 100%;
  height: 30px;
  margin: 2px 0;
  padding: 0 5px;
  border: 1px solid #ddd;
  font-size: 13px;
  vertical-align: middle;
}
.st_myreg_form tbody tr td input[type="radio"],
.st_myreg_form tbody tr td input[type="checkbox"] {
  margin: 0 5px 0 0;
}
.st_myreg_form tbody tr td textarea {
  box-sizing: border-box;
  margin: 2px 0;
  padding: 10px;
  border: 1px solid #ddd;
  line-height: 22px;
  vertical-align: middle;
}
.st_myreg_form tbody tr td select {
  height: 30px;
  margin: 2px 0;
  vertical-align: middle;
}
.st_myreg_form tbody tr td > a,
.st_myreg_form tbody tr td input[type="button"] {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  height: 30px;
  margin: 2px 0 2px 5px;
  padding: 0 15px;
  background: #dfdfdf;
  font-size: 12px;
  color: #5f5f5f;
  font-weight: bold;
  line-height: 30px;
  vertical-align: middle;
  cursor: pointer;
}
/* .st_myreg_form a:hover:before {content:'';display:block;position:absolute;top:0;bottom:0;left:0;right:0;background:rgba(0, 0, 0, .05)} */
.st_myreg_form label {
  margin-right: 15px;
  cursor: pointer;
}
.st_myreg_form .st_myreg_form_info {
  display: block;
  margin-top: 5px;
  color: #888888;
}
.st_myreg_form .st_myreg_required {
  color: #ef0000;
}
.st_myreg_form #total_price_str {
  vertical-align: top;
}

.st_myreg_app_form {
  width: 100%;
}
.st_myreg_app_form tbody tr th,
.st_myreg_app_form tbody tr td {
  padding: 5px 10px;
}
.st_myreg_app_form tbody tr th,
.st_myreg_app_form tbody tr td {
  border: 0;
}
.st_myreg_app_form tbody tr th:after {
  height: 100%;
}
.st_myreg_app_form .app_cnt_list {
  position: relative;
  width: 60px;
}
.st_myreg_app_form .app_cnt_list .app-cnt-btn {
  position: absolute;
  right: 0;
  width: 0;
  height: 0;
  text-indent: -9999px;
  border: 4px solid;
}
.st_myreg_app_form .app_cnt_list .app-cnt-btn.app-cnt-up {
  top: 4px;
  border-color: transparent transparent #000 transparent;
}
.st_myreg_app_form .app_cnt_list .app-cnt-btn.app-cnt-down {
  bottom: 4px;
  border-color: #000 transparent transparent transparent;
}
.st_myreg_app_form .app_cnt_tr {
  border-top: 1px solid #ddd;
}
.st_myreg_form.myreg_cnt_use > tbody > tr:not(:last-child) > td {
  padding: 0;
}
.st_myreg_form.myreg_cnt_use > tbody > tr > td:not(:has(.st_myreg_app_form)) {
  padding: 10px;
}

.st_myreg_payment_type {
  margin: 0 0 20px;
  padding: 15px;
  background: #f4f4f4;
  font-weight: bold;
  color: #777;
  line-height: 22px;
}
.st_myreg_payment_type input {
  margin: 0 5px 0 15px;
}
.st_myreg_payment_type:first-child {
  margin-left: 0;
}
.st_myreg_payment_type label {
  font-size: 13px;
  cursor: pointer;
}
.st_myreg_payment_type font {
  position: relative;
  top: -2px;
  margin-left: 6px;
}
.st_myreg_payment_type * {
  vertical-align: middle;
}
.st_myreg_payment_type br {
  display: none;
}

.st_myreg_btn_wrap {
  margin: 30px 0 0;
  padding: 0;
  text-align: center;
}
.st_myreg_btn_wrap a,
.st_myreg_btn_wrap button {
  margin: 2px 0;
}
.st_myreg_btn_wrap * {
  vertical-align: top;
}

.st_myreg_agree_wrap .st_myreg_agree {
  padding: 10px;
  background: #f6f6f6;
}
.st_myreg_agree_wrap .st_myreg_agree_box {
  display: block;
  overflow: auto;
  height: 150px;
  padding: 30px;
  border: 1px solid #ddd;
  background: #fff;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}
.st_myreg_agree_wrap .st_myreg_agree_box h5 {
  margin-bottom: 10px;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.st_myreg_agree_wrap .st_myreg_agree_box h5:first-child {
  margin-top: 0;
}
.st_myreg_agree_wrap .st_myreg_agree_box p,
.st_myreg_agree_wrap .st_myreg_agree_box ul,
.st_myreg_agree_wrap .st_myreg_agree_box ol {
  margin: 0;
  padding: 0;
  font-size: 13px;
  list-style-type: none;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.st_myreg_agree_wrap .st_myreg_agree_box li {
  margin-bottom: 10px;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.st_myreg_agree_wrap .st_myreg_agree_box p {
  margin-bottom: 10px;
}

.st_myreg_agree_wrap .agree_check_box {
  margin: 10px 0 0;
}
.st_myreg_agree_wrap .agree_check_box:after {
  content: "";
  display: block;
  clear: both;
}
.st_myreg_agree_wrap .agree_check_box span {
  display: inline-block;
}
.st_myreg_agree_wrap .agree_check_box input {
  float: left;
}
.st_myreg_agree_wrap .agree_check_box label {
  float: left;
  margin-left: 5px;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.st_myreg_agree_wrap .agree_check_box input[type="checkbox"] {
  display: none;
}

.st_myreg_btn_type1 {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  height: 45px;
  margin: 0;
  padding: 12px 30px;
  background: #dfdfdf;
  background: #dfdfdf;
  font-family: "Malgun Gothic", sans-serif;
  font-size: 13px;
  color: #5f5f5f;
  font-weight: bold;
  line-height: 21px;
  cursor: pointer;
}
.st_myreg_btn_type1:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}
.st_myreg_btn_type1:hover:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.05);
}
.st_myreg_btn_type1.st_myreg_highlight {
  background: #4e4e4e;
  color: #ffffff;
}
.st_myreg_btn_type1.st_myreg_highlight:hover:before {
  background: rgba(255, 255, 255, 0.15);
}

.captcha_img_code {
  margin-bottom: 5px;
}
.captcha_img_code .captcha_str {
  display: inline-block;
  padding: 4px 10px 5px;
  border: 1px solid #333;
  background: #fff;
  vertical-align: top;
}
.captcha_img_code .captcha_str img {
  vertical-align: top;
}
.captcha_img_code .captcha_input {
  margin: 0;
  vertical-align: top;
}
.captcha_img_code .captcha_input input[type="text"] {
  box-sizing: border-box;
  width: 100px;
  height: 33px;
  margin: 0 0 0 2px;
}
.captcha_help_text {
  margin: 5px 0 0;
  padding: 0;
}

@media all and (max-width: 767px) {
  .st_myreg_agree_wrap .st_myreg_agree_box {
    padding: 20px;
  }
  .st_myreg_form:after {
    content: "";
    display: block;
    clear: both;
  }
  .st_myreg_form colgroup {
    display: none;
  }
  .st_myreg_form tbody tr th {
    box-sizing: border-box;
    display: block;
    float: left;
    width: 100%;
    height: auto;
    padding: 10px;
    text-align: left;
  }
  .st_myreg_form tbody tr th:after {
    display: none;
  }
  .st_myreg_form tbody tr td {
    box-sizing: border-box;
    display: block;
    float: left;
    width: 100%;
    height: auto;
    padding: 10px;
    border-top-width: 0;
  }

  .st_myreg_payment_type br {
    display: block;
  }
  .st_myreg_payment_type input {
    margin-left: 0;
  }
  .st_myreg_agree_wrap .st_myreg_agree_box {
    height: 100px;
  }

  .st_myreg_form.myreg_cnt_use > tbody > tr > th {
    background: #f4f4f4;
  }
}
</style>
